var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex-element',{staticClass:"f-inline-block",attrs:{"element-type":_vm.elementType,"class-default-inline":"f-w-4 f-h-4 f-bg-red-600"}})}
var staticRenderFns = []

export { render, staticRenderFns }